import React from "react";
import "./JsonViewer.css";
import ReactJson from "react-json-view";

const JsonViewer = (props) => {
  return (
    <div>
      <div className="suggestions">
        <h4 className="CardHeader">
          <strong>Json Viewer</strong>
        </h4>
        <div className="CardSuggestedCards">
          <div className="card">
            <div className="cardContent">
              <ReactJson
                src={props.inputjson}
                theme="tomorrow"
                name="document"
                indentWidth="6"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JsonViewer;
